<!-- ============ DESKTOP ============ -->
<div class="relative" *ngIf="!mobile">
  <button (mouseover)="show = true" (mouseleave)="show = false" class="btn btn-outline-primary d-flex" [name]="name">
    <fa-icon [icon]="icon"></fa-icon>
  </button>
  <div class="circle pulse orange" style="position: absolute; top: 10px; right: 20px;"
    *ngIf="menu && hasNewNotifications"></div>
  <div class="absolute hide-container shadow-2" style="top: 100%; border-radius: 10px; background: white;" *ngIf="menu"
    [ngClass]="{ 'show-container': show }" (mouseover)="show = true" (mouseleave)="show = false">
    <div style="width: 300px">
      <ng-container *ngTemplateOutlet="notiList"></ng-container>
    </div>
  </div>
</div>

<!-- ============ MOBILE ============ -->
<ng-container *ngIf="mobile">
  <!-- Solo se renderiza si nadie más lo está renderizando afuera -->
  <button type="button" class="mobile-menu-item" *ngIf="!hideButton" (click)="show = !show">
    <div class="mobile-menu-item-content">
      <fa-icon [icon]="icon"></fa-icon>
      <span>{{ name }}</span>
    </div>
    <div class="circle pulse orange" *ngIf="menu && hasNewNotifications"></div>
  </button>

  <div class="mobile-dropdown" *ngIf="hideButton ? mobileOpen : show">
    <ng-container *ngTemplateOutlet="notiList"></ng-container>
  </div>
</ng-container>

<ng-template #notiList>
  <ng-container *ngIf="noti.length > 0; else noNotification">
    <div style="padding: 10px; overflow: hidden;">
      <ng-container *ngFor="let n of noti">
        <div style="padding: 2px 10px 2px 10px; cursor: pointer; position: relative" class="item-notification"
          (click)="navegar(n.link, n.abierta!, n.id!)">
          <p class="m-0" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><b>{{n.titulo}}</b></p>
          <p class="m-0" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{n.descripcion}}</p>
          <p class="text-end m-0"><small>{{n.fecha_creado | date: 'dd/MM/yyyy'}}</small></p>
          <hr class="m-0">
          <div class="circle pulse orange" style="position: absolute; top: 10px; right: 20px;" *ngIf="!n.abierta"></div>
        </div>
      </ng-container>
      <p class="mt-2 text-center" style="cursor: pointer" (click)="goNotificaciones()">Ver todo</p>
    </div>
  </ng-container>
  <ng-template #noNotification>
    <div style="padding: 10px; overflow: hidden;">
      <p class="text-center pt-2">Sin notificaciones.</p>
    </div>
  </ng-template>
</ng-template>